// extracted by mini-css-extract-plugin
export default {"reviewTitleBar":"ReviewTitleBar_reviewTitleBar__XyGBy"};